module.exports = __webpack_public_path__ + "static/media/adey-bennett-loop-2.d2546cee.jpg";